var _style, _g, _polyline;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartylockers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 307.9 89.5",
    style: {
      enableBackground: "new 0 0 307.9 89.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#951B81;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000170963891007003299420000001096267923458586752_);}\n\t.st3{fill:url(#SVGID_00000050664630490697980790000012136656341105906305_);}\n\t.st4{fill:url(#SVGID_00000067200069748765042380000007548792719449993150_);}\n\t.st5{fill:url(#SVGID_00000035490368809904540420000010789589873305784222_);}\n\t.st6{fill:url(#SVGID_00000008125390076488261360000002179197723093544588_);}\n\t.st7{fill:url(#SVGID_00000005955271115696190170000001528146265471846534_);}\n\t.st8{fill:url(#SVGID_00000040556211656984317310000004451639610815034792_);}\n\t.st9{fill:url(#SVGID_00000171708355094103130260000005414395045823225260_);}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M83.7,54.3h-3.8c-0.4,0-0.6-0.2-0.6-0.6V32.8c0-0.4,0.2-0.6,0.6-0.6h8.3c1.6,0,3,0.3,4.1,0.9c1.2,0.6,2.1,1.5,2.7,2.6 s1,2.4,1,3.8c0,1.5-0.3,2.8-0.9,4s-1.5,2-2.7,2.7c-1.2,0.6-2.6,1-4.2,1h-3.9v6.5C84.3,54,84.1,54.3,83.7,54.3z M89.4,42.2 c0.5-0.3,0.8-0.6,1.1-1.1c0.3-0.5,0.4-1,0.4-1.5s-0.1-1-0.4-1.5c-0.3-0.4-0.6-0.8-1.1-1s-1-0.4-1.6-0.4h-3.5v5.7h3.5 C88.4,42.5,88.9,42.4,89.4,42.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.7,35.3h2.7c0.4,0,0.6,0.2,0.6,0.6v17.7c0,0.4-0.2,0.6-0.6,0.6h-2.8c-0.3,0-0.6-0.2-0.7-0.5l-0.3-1.3 c-1.4,1.5-3.1,2.2-5.2,2.2c-1.8,0-3.4-0.4-4.9-1.3s-2.7-2.1-3.5-3.6c-0.9-1.5-1.3-3.2-1.3-5s0.4-3.4,1.3-4.9s2-2.7,3.5-3.6 c1.5-0.9,3.1-1.3,4.9-1.3c2.1,0,3.9,0.7,5.3,2.2l0.4-1.4C112.1,35.5,112.3,35.3,112.7,35.3z M109,49.4c0.8-0.4,1.4-1.1,1.8-1.8 c0.4-0.8,0.7-1.7,0.7-2.7s-0.2-1.9-0.7-2.7c-0.4-0.8-1-1.4-1.8-1.9s-1.6-0.7-2.6-0.7c-0.9,0-1.8,0.2-2.5,0.7 c-0.8,0.5-1.3,1.1-1.8,1.9c-0.4,0.8-0.6,1.7-0.6,2.7s0.2,1.9,0.6,2.7s1,1.4,1.8,1.8c0.7,0.4,1.6,0.7,2.5,0.7 C107.4,50,108.2,49.8,109,49.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.2,36.1c0.2,0.1,0.3,0.3,0.3,0.5c0,0.1,0,0.2-0.1,0.3l-1.6,3c-0.1,0.2-0.3,0.3-0.5,0.3c-0.1,0-0.2,0-0.4-0.1 c-0.8-0.4-1.6-0.6-2.3-0.6s-1.4,0.2-2,0.6c-0.6,0.4-1.1,1-1.5,1.8s-0.6,1.7-0.6,2.8v9c0,0.4-0.2,0.6-0.6,0.6h-3.6 c-0.4,0-0.6-0.2-0.6-0.6V35.9c0-0.4,0.2-0.6,0.6-0.6h2.7c0.4,0,0.6,0.2,0.7,0.5l0.6,1.8c0.6-0.8,1.3-1.5,2.1-1.9 c0.8-0.5,1.7-0.7,2.8-0.7C130.7,35,132,35.3,133.2,36.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.4,54.3h-3.6c-0.4,0-0.6-0.2-0.6-0.6V39.8h-1.7c-0.4,0-0.6-0.2-0.6-0.6V36c0-0.4,0.2-0.6,0.6-0.6h1.7v-4.2 c0-0.4,0.2-0.6,0.6-0.7l3.6-0.7c0,0,0.1,0,0.2,0c0.2,0,0.3,0.1,0.4,0.2c0.1,0.1,0.1,0.2,0.1,0.4v5h3.1c0.4,0,0.6,0.2,0.6,0.6v3.2 c0,0.4-0.2,0.6-0.6,0.6h-3.1v13.9C141.1,54,140.8,54.3,140.4,54.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.3,59.8h-3.8c-0.2,0-0.3,0-0.4-0.1c-0.1-0.1-0.1-0.2-0.1-0.3s0-0.2,0.1-0.3l2-4.9L145,36c0-0.1,0-0.2,0-0.3 s0-0.3,0.1-0.3c0.1-0.1,0.2-0.1,0.4-0.1h4c0.4,0,0.6,0.2,0.7,0.5l4.2,12.3l4.2-12.3c0.1-0.3,0.3-0.5,0.7-0.5h4 c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.1,0.2,0.1,0.3s0,0.2,0,0.3L155,59.3C154.9,59.7,154.6,59.8,154.3,59.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.1,54.3h-3.5c-0.4,0-0.6-0.2-0.6-0.6V31c0-0.4,0.2-0.6,0.6-0.6l3.5-0.7c0.4,0,0.6,0.2,0.6,0.6v23.3 C170.7,54,170.5,54.3,170.1,54.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.3,53.4c-1.5-0.9-2.7-2.1-3.6-3.6c-0.9-1.5-1.3-3.1-1.3-4.9c0-1.8,0.4-3.5,1.3-5c0.9-1.5,2.1-2.7,3.6-3.6 c1.5-0.9,3.2-1.3,5-1.3s3.5,0.4,5,1.3c1.5,0.9,2.7,2.1,3.6,3.6c0.9,1.5,1.3,3.2,1.3,5s-0.5,3.4-1.4,4.9s-2.1,2.7-3.7,3.6 c-1.5,0.9-3.2,1.3-5,1.3C181.5,54.7,179.8,54.3,178.3,53.4z M185.9,49.4c0.8-0.5,1.4-1.1,1.9-1.9c0.5-0.8,0.7-1.7,0.7-2.7 s-0.2-1.9-0.7-2.7s-1.1-1.4-1.9-1.9c-0.8-0.5-1.7-0.7-2.6-0.7s-1.8,0.2-2.6,0.7s-1.4,1.1-1.9,1.9c-0.5,0.8-0.7,1.7-0.7,2.7 s0.2,1.9,0.7,2.7s1.1,1.4,1.9,1.9c0.8,0.5,1.7,0.7,2.6,0.7S185.1,49.9,185.9,49.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.5,53.4c-1.5-0.9-2.7-2.1-3.5-3.6s-1.3-3.2-1.3-4.9c0-1.8,0.4-3.5,1.3-5c0.8-1.5,2-2.7,3.5-3.6c1.5-0.9,3.2-1.3,5-1.3 c1.2,0,2.4,0.2,3.5,0.6s2.1,0.9,2.9,1.6c0.2,0.1,0.3,0.3,0.3,0.5c0,0.1,0,0.2-0.1,0.4l-1.7,2.5c-0.1,0.2-0.3,0.3-0.5,0.3 c-0.1,0-0.3-0.1-0.4-0.2c-0.6-0.4-1.1-0.7-1.7-0.9c-0.6-0.2-1.3-0.3-2-0.3c-0.9,0-1.8,0.2-2.6,0.7s-1.4,1.1-1.9,2 c-0.5,0.8-0.7,1.8-0.7,2.8s0.2,2,0.7,2.8s1.1,1.5,1.9,2c0.8,0.5,1.7,0.7,2.6,0.7c0.7,0,1.4-0.1,2-0.3s1.2-0.5,1.7-0.9 c0.2-0.1,0.3-0.2,0.4-0.2c0.2,0,0.3,0.1,0.5,0.3l1.7,2.5c0.1,0.1,0.2,0.3,0.2,0.4c0,0.1-0.1,0.3-0.2,0.4c-0.9,0.7-1.9,1.2-3,1.6 c-1.1,0.4-2.3,0.6-3.6,0.6C202.6,54.7,201,54.3,199.5,53.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.8,53.9c0,0.1,0,0.2-0.1,0.3s-0.2,0.1-0.4,0.1H227c-0.3,0-0.6-0.1-0.8-0.4l-5-7.4l-2.4,2.6v4.6c0,0.4-0.2,0.6-0.6,0.6 h-3.6c-0.4,0-0.6-0.2-0.6-0.6V31c0-0.4,0.2-0.6,0.6-0.6l3.6-0.7c0.4,0,0.6,0.2,0.6,0.6v12.5l6.2-7.1c0.2-0.2,0.5-0.3,0.8-0.3h4.8 c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.1,0.1,0.1,0.3c0,0.1-0.1,0.3-0.2,0.4l-6.4,6.9l7.1,10.6C231.8,53.6,231.8,53.8,231.8,53.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.5,53.4c-1.5-0.9-2.7-2.1-3.5-3.6s-1.3-3.2-1.3-4.9c0-1.8,0.4-3.4,1.2-5c0.8-1.5,1.9-2.7,3.3-3.6 c1.4-0.9,3-1.3,4.8-1.3c1.9,0,3.6,0.4,5,1.3c1.4,0.8,2.5,2,3.3,3.5c0.7,1.5,1.1,3.2,1.1,5.1c0,0.3,0,0.7,0,1.1 c0,0.4-0.3,0.5-0.7,0.5h-13c0.2,0.8,0.6,1.5,1.1,2.1s1.1,1,1.8,1.4c0.7,0.3,1.4,0.5,2.2,0.5c0.7,0,1.4-0.1,2-0.3s1.2-0.5,1.7-0.9 c0.1-0.1,0.3-0.2,0.4-0.2c0.2,0,0.3,0.1,0.5,0.3l1.7,2.4c0.1,0.2,0.2,0.3,0.2,0.4c0,0.2-0.1,0.3-0.3,0.5c-0.9,0.7-1.9,1.2-2.9,1.6 c-1.1,0.4-2.2,0.6-3.5,0.6C239.7,54.7,238,54.3,236.5,53.4z M244.1,40.1c-0.8-0.7-1.7-1-2.9-1c-1.1,0-2.1,0.3-2.9,1 c-0.8,0.7-1.4,1.6-1.7,2.7h9C245.4,41.7,244.9,40.8,244.1,40.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.4,36.1c0.2,0.1,0.3,0.3,0.3,0.5c0,0.1,0,0.2-0.1,0.3l-1.6,3c-0.1,0.2-0.3,0.3-0.5,0.3c-0.1,0-0.2,0-0.4-0.1 c-0.8-0.4-1.6-0.6-2.3-0.6c-0.7,0-1.4,0.2-2,0.6c-0.6,0.4-1.1,1-1.5,1.8s-0.6,1.7-0.6,2.8v9c0,0.4-0.2,0.6-0.6,0.6h-3.6 c-0.4,0-0.6-0.2-0.6-0.6V35.9c0-0.4,0.2-0.6,0.6-0.6h2.7c0.4,0,0.6,0.2,0.7,0.5l0.6,1.8c0.6-0.8,1.3-1.5,2.1-1.9 c0.8-0.5,1.7-0.7,2.8-0.7C263.9,35,265.1,35.3,266.4,36.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.9,51.9c-0.2-0.1-0.3-0.3-0.3-0.5c0-0.1,0.1-0.3,0.2-0.4l1.8-2.2c0.1-0.2,0.3-0.3,0.5-0.3c0.1,0,0.3,0.1,0.4,0.2 c0.7,0.5,1.5,1,2.3,1.3s1.6,0.5,2.4,0.5c0.6,0,1.2-0.1,1.5-0.4c0.4-0.3,0.6-0.7,0.6-1.1c0-0.3-0.1-0.6-0.3-0.8 c-0.2-0.2-0.6-0.5-1.1-0.7s-1.2-0.5-2-0.8c-1.6-0.5-2.9-1.2-3.9-2.2c-1-0.9-1.5-2.2-1.5-3.7c0-1,0.2-1.9,0.7-2.8 c0.5-0.9,1.3-1.6,2.3-2.1s2.3-0.8,3.7-0.8c1,0,2.1,0.2,3.2,0.6c1.1,0.4,2,1,2.9,1.8c0.1,0.1,0.2,0.3,0.2,0.4 c0,0.2-0.1,0.3-0.2,0.4l-2.2,2.2c-0.1,0.1-0.3,0.2-0.4,0.2s-0.3-0.1-0.4-0.2c-0.5-0.3-1-0.6-1.5-0.9c-0.6-0.2-1.1-0.3-1.7-0.3 s-1.1,0.1-1.5,0.4c-0.3,0.3-0.5,0.6-0.5,1c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.6,0.4,1,0.7c0.5,0.2,1.2,0.5,2,0.7 c1.8,0.6,3.1,1.3,4.1,2.2s1.4,2.1,1.4,3.7c0,1-0.3,2-0.8,2.9s-1.3,1.6-2.3,2.2c-1,0.6-2.2,0.8-3.5,0.8 C271.6,54.7,269.1,53.8,266.9,51.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M289.8,38.1c-0.5-0.3-0.9-0.7-1.2-1.3c-0.3-0.5-0.4-1.1-0.4-1.7c0-0.6,0.1-1.2,0.4-1.8c0.3-0.5,0.7-1,1.2-1.3 c0.5-0.3,1-0.5,1.7-0.5s1.2,0.2,1.7,0.5c0.5,0.3,0.9,0.7,1.1,1.3c0.3,0.5,0.4,1.1,0.4,1.8c0,0.1,0,0.2,0,0.3s-0.1,0.2-0.2,0.2 h-4.8c0.1,0.3,0.2,0.6,0.4,0.9c0.2,0.3,0.4,0.5,0.7,0.6c0.3,0.1,0.6,0.2,0.9,0.2c0.5,0,1-0.2,1.5-0.5c0,0,0.1-0.1,0.2-0.1 s0.1,0,0.2,0.1l0.5,0.7c0,0.1,0.1,0.1,0.1,0.1c0,0.1,0,0.1-0.1,0.2c-0.3,0.3-0.7,0.4-1.1,0.6s-0.8,0.2-1.2,0.2 C290.9,38.5,290.3,38.4,289.8,38.1z M292.6,33.2c-0.3-0.3-0.7-0.4-1.2-0.4c-0.3,0-0.6,0.1-0.8,0.2c-0.3,0.1-0.5,0.3-0.6,0.6 c-0.2,0.2-0.3,0.5-0.4,0.9h3.6C293.1,33.9,292.9,33.5,292.6,33.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.5,31.6h1c0.1,0,0.2,0.1,0.2,0.2v6.3c0,0.1-0.1,0.2-0.2,0.2h-0.8c-0.1,0-0.2-0.1-0.2-0.2l-0.1-0.6 c-0.2,0.3-0.6,0.5-1,0.7s-0.8,0.3-1.2,0.3c-0.5,0-1-0.1-1.4-0.4c-0.4-0.2-0.7-0.6-1-1c-0.2-0.4-0.3-1-0.3-1.5v-3.7 c0-0.1,0.1-0.2,0.2-0.2h1c0.1,0,0.2,0.1,0.2,0.2v3.5c0,0.4,0.1,0.7,0.2,0.9c0.1,0.3,0.3,0.5,0.6,0.6c0.2,0.1,0.5,0.2,0.8,0.2 s0.6-0.1,0.9-0.2c0.3-0.2,0.5-0.4,0.6-0.6c0.2-0.3,0.2-0.5,0.2-0.9v-3.6C300.3,31.7,300.4,31.6,300.5,31.6z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 282.5,
    y: 35,
    className: "st0",
    width: 3.5,
    height: 3.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -2300.6375,
    y1: 2094.6755,
    x2: -2286.8193,
    y2: 2094.6755,
    gradientTransform: "matrix(-1 0 0 1 -2254.677 -2066.5256)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#951B81"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CB8ABB"
    }
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "46,5.3 32.1,19.2 32.1,19.2 32.1,51 46,51 46,19.2 46,19.2 46,5.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110433439243946340380000012519492359011141020_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.8,
    y1: 5.0913,
    x2: 12.8,
    y2: 50.7913,
    gradientTransform: "matrix(1 0 0 -1 0 89.2914)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#951B81"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CB8ABB"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "url(#SVGID_00000110433439243946340380000012519492359011141020_)"
    },
    points: "5.9,84.2 19.7,70.4 19.7,70.4  19.7,38.5 5.9,38.5 5.9,70.4 5.9,70.4 5.9,84.2  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140716091177618737930000012764386043281570964_",
    gradientUnits: "userSpaceOnUse",
    x1: -2391.3982,
    y1: -24.9891,
    x2: -2391.3982,
    y2: 28.9109,
    gradientTransform: "matrix(0 -1 -1 0 34.8109 -2333.4983)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#951B81"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CB8ABB"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000140716091177618737930000012764386043281570964_)"
    },
    points: "32.1,64.8 19.7,64.8 19.7,64.8  5.9,64.8 19.7,51 19.7,51 32.1,51 32.1,51 45.9,51 46,51 59.8,64.8 45.9,64.8 45.9,64.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085218264426012814690000015532371591581131948_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.1425,
    y1: 57.6913,
    x2: 5.8551,
    y2: 57.6913,
    gradientTransform: "matrix(1 0 0 -1 0 89.2914)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#951B81"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1018,
    style: {
      stopColor: "#A0348B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1763,
    style: {
      stopColor: "#AD4E98"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2607,
    style: {
      stopColor: "#B865A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3574,
    style: {
      stopColor: "#C076AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    style: {
      stopColor: "#C681B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6308,
    style: {
      stopColor: "#CA88BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CB8ABB"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000085218264426012814690000015532371591581131948_)"
    },
    points: "19.7,38.5 5.9,38.5 19.7,24.7  19.7,24.7 32.1,24.7 32.1,38.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011001122441546008060000006145216723478107057_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.0846,
    y1: 25.0439,
    x2: 12.5072,
    y2: 18.4445,
    gradientTransform: "matrix(1 0 0 -1 0 89.2914)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7B146A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06865692,
    style: {
      stopColor: "#7F156E",
      stopOpacity: 0.9313
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2678,
    style: {
      stopColor: "#891876",
      stopOpacity: 0.7322
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4797,
    style: {
      stopColor: "#901A7C",
      stopOpacity: 0.5203
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7114,
    style: {
      stopColor: "#941B80",
      stopOpacity: 0.2886
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#951B81",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 5.9,
    y: 64.8,
    style: {
      fill: "url(#SVGID_00000011001122441546008060000006145216723478107057_)"
    },
    width: 13.8,
    height: 5.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069364832580044528720000015724616254242643633_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.0835,
    y1: 51.3319,
    x2: 12.5061,
    y2: 44.7325,
    gradientTransform: "matrix(1 0 0 -1 0 89.2914)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7B146A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06865692,
    style: {
      stopColor: "#7F156E",
      stopOpacity: 0.9313
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2678,
    style: {
      stopColor: "#891876",
      stopOpacity: 0.7322
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4797,
    style: {
      stopColor: "#901A7C",
      stopOpacity: 0.5203
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7114,
    style: {
      stopColor: "#941B80",
      stopOpacity: 0.2886
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#951B81",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 5.9,
    y: 38.5,
    style: {
      fill: "url(#SVGID_00000069364832580044528720000015724616254242643633_)"
    },
    width: 13.8,
    height: 5.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127008649608515984900000011660911947197146773_",
    gradientUnits: "userSpaceOnUse",
    x1: -254.1007,
    y1: 2668.9006,
    x2: -254.6781,
    y2: 2662.3013,
    gradientTransform: "matrix(0 1 1 0 -2636.179 312.2914)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7B146A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06865692,
    style: {
      stopColor: "#7F156E",
      stopOpacity: 0.9313
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2678,
    style: {
      stopColor: "#891876",
      stopOpacity: 0.7322
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4797,
    style: {
      stopColor: "#901A7C",
      stopOpacity: 0.5203
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7114,
    style: {
      stopColor: "#941B80",
      stopOpacity: 0.2886
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#951B81",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000127008649608515984900000011660911947197146773_)"
    },
    points: "26.7,64.8 26.7,51 32.1,51  32.1,64.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031186707014044974800000007215706404845158310_",
    gradientUnits: "userSpaceOnUse",
    x1: -280.4006,
    y1: 2668.9019,
    x2: -280.978,
    y2: 2662.3025,
    gradientTransform: "matrix(0 1 1 0 -2636.179 312.2914)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7B146A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06865692,
    style: {
      stopColor: "#7F156E",
      stopOpacity: 0.9313
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2678,
    style: {
      stopColor: "#891876",
      stopOpacity: 0.7322
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4797,
    style: {
      stopColor: "#901A7C",
      stopOpacity: 0.5203
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7114,
    style: {
      stopColor: "#941B80",
      stopOpacity: 0.2886
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#951B81",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000031186707014044974800000007215706404845158310_)"
    },
    points: "26.7,38.5 26.7,24.7 32.1,24.7  32.1,38.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121239978468408222480000013878273887176561805_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.05,
    y1: 24.4913,
    x2: 39.05,
    y2: 70.1536,
    gradientTransform: "matrix(1 0 0 -1 0 89.2914)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#951B81"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CB8ABB"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000121239978468408222480000013878273887176561805_)"
    },
    points: "32.1,51 32.1,64.8 46,51 46,51  46,19.2 32.1,19.2  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartylockers);
export default __webpack_public_path__ + "static/media/partylockers.ab501079316534bcf3b08ed061d677bb.svg";
export { ForwardRef as ReactComponent };